




























import Vue from 'vue';

export default Vue.extend({
  name: 'SorBetaSwitcher',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    disabledLabel: {
      type: String,
      required: false,
      default: undefined,
    },
    enabledLabel: {
      type: String,
      required: false,
      default: undefined,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isLabeled(): boolean {
      return !!(this.disabledLabel || this.enabledLabel);
    },
  },
  methods: {
    input(ev: MouseEvent) {
      this.$emit('input', (ev.target as HTMLFormElement).checked);
    },
  },
});
